import React from "react"
import { CampaignDetailComponent } from "./campaignDetailComponent";

export default class ChildCampaignDetailsComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <>
                <CampaignDetailComponent
                    {...this.props}
                    isCreateChildCampaign={true}
                />
            </>
        );
    };
};